import React, { useMemo } from "react";
import { Modal } from "@pacificoseguros/pixie/react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { ClosePayrollFileErrorModal } from "../../redux/payroll-file/actions/default";
import { ERROR_MODALS } from "./constants/payroll-errors";
import IncorrectExtensionModal from "./components/incorrect-extension-modal";
import "./payroll-error-modal.scss";
import LimitWorkersModal from "./components/limit-workers-modal";
import FormatErrorsModal from "./components/format-errors-modal";
import ColumnFormatErrorsModal from "./components/column-format-errors-modal";
import { DatalayerModal } from "../../libs/datalayer/components/datalayer-modal";

const PayrollErrorModal: React.FC = () => {
    const dispatch = useDispatch();
    const {
        error: { isOpen, typeModal },
    } = useSelector((state: RootState) => state.payroll_file);

    const closeModal = () => {
        dispatch(new ClosePayrollFileErrorModal().create());
    };
    const datalayerModalName = useMemo(() => {
        switch (typeModal) {
            case ERROR_MODALS.INCORRECT_EXTENSION:
                return "Archivo planilla extensión incorrecta";
            case ERROR_MODALS.LIMIT_WORKERS:
                return "Archivo planilla supera cantidad trabajadores";
            case ERROR_MODALS.FORMAT_ERRORS:
                return "Archivo planilla con errores en formato";
            case ERROR_MODALS.FORMAT_COLUMNS_ERRORS:
                return "Archivo planilla con errores por columna";
        }
    }, [typeModal]);
    const modalContent = useMemo(() => {
        if (typeModal === ERROR_MODALS.INCORRECT_EXTENSION) {
            return <IncorrectExtensionModal />;
        }

        if (typeModal === ERROR_MODALS.LIMIT_WORKERS) {
            return <LimitWorkersModal />;
        }

        if (typeModal === ERROR_MODALS.FORMAT_ERRORS) {
            return <FormatErrorsModal />;
        }

        if (typeModal === ERROR_MODALS.FORMAT_COLUMNS_ERRORS) {
            return <ColumnFormatErrorsModal />;
        }

        return null;
    }, [typeModal]);

    return (
        <>
            {isOpen && (
                <DatalayerModal
                    open={isOpen}
                    onClose={closeModal}
                    className="payroll-error-modal"
                    as={Modal}
                    type="Error"
                    name={datalayerModalName}
                >
                    <React.Suspense fallback={null}>
                        {modalContent}
                    </React.Suspense>
                </DatalayerModal>
            )}
        </>
    );
};

export default PayrollErrorModal;
